import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode } from "vue";
const _hoisted_1 = { class: "flex flex-col items-center justify-center w-full h-full gap-2" };
const _hoisted_2 = ["src"];
const _hoisted_3 = /*#__PURE__*/ _createStaticVNode("<g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M15.312 0H23.5c7.318 0 13.25 5.932 13.25 13.25v8a5.25 5.25 0 0010.5 0v-8C47.25 5.932 53.182 0 60.5 0h8.188c5.636 0 10.28 4.42 10.56 10.05l4.202 84.855c.29 5.831-4.204 10.793-10.036 11.082-.174.009-.348.013-.523.013H11.11C5.27 106 .537 101.267.537 95.428c0-.175.004-.35.013-.523l4.202-84.856A10.572 10.572 0 0115.312 0z\" fill=\"#6284D6\"></path><g transform=\"translate(32.813 37.1)\"><path d=\"M16.58 12.093a7.782 7.782 0 00-8.387 2.272\" stroke=\"#00292B\" stroke-width=\"1.982\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><ellipse fill=\"#00292B\" cx=\"1.313\" cy=\"1.325\" rx=\"1.313\" ry=\"1.325\"></ellipse><ellipse fill=\"#00292B\" cx=\"17.063\" cy=\"1.325\" rx=\"1.313\" ry=\"1.325\"></ellipse></g><path stroke=\"#F7F7FF\" stroke-width=\"1.5\" fill=\"#F7F7FF\" stroke-linejoin=\"round\" d=\"M68 31h40v32H68z\"></path><path stroke=\"#DDDBEA\" stroke-width=\"2\" stroke-linecap=\"square\" d=\"M80.25 40.25L95.5 55.5\"></path><circle stroke=\"#DDDBEA\" stroke-width=\"2\" cx=\"88\" cy=\"48\" r=\"12\"></circle></g>", 1);
const _hoisted_4 = [
    _hoisted_3
];
const _hoisted_5 = { class: "text-2xl font-bold text-primary-900 dark:text-gray-200" };
const _hoisted_6 = { class: "flex flex-col items-center text-sm text-primary-900 dark:text-gray-200" };
import componentI18n from '@/i18n/componentI18n';
const __default__ = {
    ...componentI18n('components.no_results')
};
export default /*#__PURE__*/ _defineComponent({
    ...__default__,
    __name: 'NoResults',
    props: {
        query: null,
        searchBy: null
    },
    setup(__props) {
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (_openBlock(), _createElementBlock("svg", {
                    width: "109",
                    height: "106",
                    xmlns: "http://www.w3.org/2000/svg",
                    "svg-inline": '',
                    src: '@/assets/images/no-results.svg',
                    alt: '',
                    class: _normalizeClass('w-28 h-28')
                }, _hoisted_4, 8, _hoisted_2)),
                _createElementVNode("h1", _hoisted_5, _toDisplayString(_ctx.$t('no_matches', { query: __props.query })), 1),
                _createElementVNode("h2", _hoisted_6, [
                    _createElementVNode("div", null, _toDisplayString(_ctx.$t('double_check')), 1),
                    _createElementVNode("div", null, _toDisplayString(_ctx.$t('keep_in_mind')) + " " + _toDisplayString(__props.searchBy), 1)
                ])
            ]));
        };
    }
});
